module.exports = __webpack_public_path__ + "media/images/hello_drifter_logo_line_blk-a4cb87b98ab3799636b82b693d8ebc14.png";